"use strict";

module.exports = function() {
	// Начинаем счет с 1
	Handlebars.registerHelper("counter", function (index) {
		return index + 1;
	});

	Handlebars.registerHelper("provisionSpan", function (provision) {
		var labelClass = 'label';

		if (provision == 0) {
			labelClass += ' label-danger';
		} else if (provision > 0 && provision < 0.5) {
			labelClass += ' label-warning';
		} else if (provision >= 0.5) {
			labelClass += ' label-primary';
		} else {
			provision = 'n/a';
		}

		return '<span class="' + labelClass + '">' + provision + '</span>';
	});

	Handlebars.registerHelper("provisionHeaderSpan", function (provision) {
		var labelClass = 'label label-h3';

		if (provision == 0) {
			labelClass += ' label-danger';
		} else if (provision > 0 && provision < 0.5) {
			labelClass += ' label-warning';
		} else if (provision >= 0.5) {
			labelClass += ' label-primary';
		} else {
			provision = 'n/a';
		}

		return '<span class="' + labelClass + '">' + provision + '</span>';
	});

	Handlebars.registerHelper("copiesCountByType", function (count, type) {
		if (type == 'ЭБС') {
			return 'Инд. неогр. доступ';
		} else {
			return count;
		}
	});

	Handlebars.registerHelper("programDisciplineLink", function (
		level_type, specialty, year, faculty, study_form, spec_num, profile, period, educ_progr_type,
		discipline, apiUrl, templateName
	) {
		var rawUrl = "/report/programs/discipline/?level_type=" + level_type
				+ "&specialty=" + specialty + "&year=" + year + "&faculty=" + faculty + "&study_form=" + study_form
				+ "&spec_num=" + spec_num + "&profile=" + profile + "&period=" + period
				+ '&educ_progr_type=' + educ_progr_type + "&discipline=" + discipline,
			text = Handlebars.escapeExpression(discipline),
			dataParams = "data-request_level_type='" + level_type + "'" + " data-request_specialty='" + specialty + "'"
				+ " data-request_year='" + year + "' data-request_faculty='" + faculty + "'"
				+ " data-request_study_form='" + study_form + "' data-request_spec_num='" + spec_num + "'"
				+ " data-request_profile='" + profile + "' data-request_period='" + period + "'"
				+ " data-request_educ_progr_type='" + educ_progr_type + "' data-request_discipline='" + discipline + "'"
				+ " data-api-url='" + Handlebars.escapeExpression(apiUrl) + "'"
				+ " data-template-name='" + templateName + "'";

		if (window.location.search.indexOf('real') != -1) {
			rawUrl += "&real=true";
		}

		return new Handlebars.SafeString(
			"<a js-discipline-link " + dataParams + " href='" + Handlebars.escapeExpression(rawUrl) + "'>" + text + "</a>"
		);
	});

	Handlebars.registerHelper("departmentDisciplineLink", function (department, discipline, apiUrl, templateName) {
		var rawUrl = '/report/departments/discipline/?department=' + department + '&discipline=' + discipline,
			text = Handlebars.escapeExpression(discipline),
			dataParams = "data-request_department='" + department + "' data-request_discipline='" + discipline + "'"
				+ " data-api-url='" + Handlebars.escapeExpression(apiUrl) + "'"
				+ " data-template-name='" + templateName + "'";

		if (window.location.search.indexOf('real') != -1) {
			rawUrl += "&real=true";
		}

		return new Handlebars.SafeString(
			"<a js-discipline-link " + dataParams + " href='" + Handlebars.escapeExpression(rawUrl) + "'>" + text + "</a>"
		);
	});

	Handlebars.registerHelper("lowDepartmentDisciplineLink", function (department, discipline, apiUrl, templateName) {
		var rawUrl = '/report/low/discipline/?department=' + department + '&discipline=' + discipline,
			text = Handlebars.escapeExpression(discipline),
			dataParams = "data-request_department='" + department + "' data-request_discipline='" + discipline + "'"
				+ " data-api-url='" + Handlebars.escapeExpression(apiUrl) + "'"
				+ " data-template-name='" + templateName + "'";

		if (window.location.search.indexOf('real') != -1) {
			rawUrl += "&real=true";
		}

		return new Handlebars.SafeString(
			"<a js-discipline-link " + dataParams + " href='" + Handlebars.escapeExpression(rawUrl) + "'>" + text + "</a>"
			+ "<br>Кафедра: " + department
		);
	});

	Handlebars.registerHelper("bibliographicRecord", function (string) {
		string = string.replace(/([^>])\n/g, '$1<br/>');
		string = string.replace(/URL: (.+?)\.(\s|$)/g, 'URL: <a href="$1" target="_blank">$1</a>. ');

		return new Handlebars.SafeString(string);
	});
};